import axios from "axios"

class API {
  static setAxiosDefaults() {
    axios.defaults.baseURL = "/api"
    axios.defaults.xsrfCookieName = "CSRF-TOKEN"
    axios.defaults.xsrfHeaderName = "X-CSRF-Token"
    axios.defaults.withCredentials = true
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    axios.defaults.headers.common["Accept"] = "application/json"
  }

  static async get(path, params = {}, options = {}) {
    try {
      const response = await axios.get(path, { params, ...options })
      return response.data
    } catch (error) {
      return API.handleError(error)
    }
  }

  static async post(path, body, options = {}) {
    try {
      const response = await axios.post(path, body, options)
      return response.data
    } catch (error) {
      return API.handleError(error)
    }
  }

  static async postFileUpload(path, files, data, options = {}) {
    const formData = new FormData()

    if (Array.isArray(files)) {
      files.map((file) => formData.append("file[]", file))
    } else {
      formData.append("file", files)
    }

    if (data) {
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
      })
    }

    options["Content-Type"] = "multipart/form-data"
    return this.post(path, formData, options)
  }

  static async put(path, data, options = {}) {
    try {
      const response = await axios.put(path, data, options)
      return response.data
    } catch (error) {
      return API.handleError(error)
    }
  }

  static async delete(path, params, options = {}) {
    try {
      const response = await axios.delete(path, { params, ...options })
      return response.data
    } catch (error) {
      return API.handleError(error)
    }
  }

  static isLocalhost() {
    const url = new URL(window.location)
    return url.hostname === "localhost"
  }

  static handleError(error) {
    if (error.response && error.response.status === 401) {
      window.location.href = "/sign_in"
    } else {
      throw error
    }
  }
}

API.setAxiosDefaults()

export default API
